// ✅ Merged & Final StaffAnnouncement.jsx with "Assign Staff" section added from AddProgram

import React, { useState } from "react";
import styles from "./StaffAnnouncement.module.css";
import { BsUpload } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import CalendarInput from "../../components/CalendarInput/CalendarInput";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";
import ToClose from "../../components/ToClose/ToClose";
import { TbActivityHeartbeat } from "react-icons/tb";
import { FaUserPlus } from "react-icons/fa";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";

const StaffAnnouncement = () => {
  const dispatch = useDispatch();

  const [activity, setActivity] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [rooms, setRooms] = useState("");
  const [labels, setLabels] = useState("");
  const [notifyStaff, setNotifyStaff] = useState("");
  const [url, setUrl] = useState("");
  const [videoFile, setVideoFile] = useState(null);
  const [description, setDescription] = useState("");

  const [search, setSearch] = useState("");
  const [selectedStaff, setSelectedStaff] = useState([]);

  const dummyStaff = [
    { id: "s1", name: "John" },
    { id: "s2", name: "Steeve" },
    { id: "s3", name: "Alice" },
  ];

  const filteredStaff = dummyStaff.filter((staff) =>
    staff.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleCheckboxChange = (id) => {
    setSelectedStaff((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleSave = () => {
    console.log("Selected Staff IDs:", selectedStaff);
    dispatch(closeModal());
  };

  const handleCancel = () => {
    setSelectedStaff([]);
    setSearch("");
  };

  const handleVideoUpload = (e) => {
    setVideoFile(e.target.files[0]);
  };

  return (
    <div className={styles.container}>
      <div className={styles.announcementWrapper}>
        <div className={styles.header}>
          <HeadingAndIcon
            heading="Staff Announcement"
            icon={<TbActivityHeartbeat />}
          />
          <ToClose onClose={() => dispatch(closeModal())} />
        </div>

        <div className={styles.sectionBox}>
          <div className={styles.sectionShell}>
            <div className={styles.sectionHeaderBox}>
              <HeadingAndIcon
                icon={<TbActivityHeartbeat />}
                heading="Activity Details"
              />
            </div>

            <div className={styles.inputCard}>
              <div className={styles.inputsRow}>
                <div className={styles.inputBox}>
                  <HeadingAndDropDown
                    label="Activity"
                    name="activity"
                    value={activity}
                    onChange={(e) => setActivity(e.target.value)}
                    options={[{ label: "Play", value: "play" }]}
                  />
                </div>
                <div className={styles.inputBox}>
                  <CalendarInput
                    fieldLabel="Date *"
                    value={date}
                    onChange={setDate}
                  />
                </div>
                <div className={styles.inputBox}>
                  <label>Time *</label>
                  <input
                    type="time"
                    className={styles.input}
                    value={time}
                    onChange={(e) => setTime(e.target.value)}
                  />
                </div>
              </div>

              <div className={styles.inputsRow}>
                <div className={styles.inputBox}>
                  <HeadingAndDropDown
                    label="Rooms"
                    name="rooms"
                    value={rooms}
                    onChange={(e) => setRooms(e.target.value)}
                    options={[{ label: "Room 1", value: "r1" }]}
                  />
                </div>
                <div className={styles.inputBox}>
                  <HeadingAndDropDown
                    label="Labels"
                    name="labels"
                    value={labels}
                    onChange={(e) => setLabels(e.target.value)}
                    options={[{ label: "Urgent", value: "urgent" }]}
                  />
                </div>
                <div className={styles.inputBox}>
                  <HeadingAndDropDown
                    label="Notify Staff"
                    name="notifyStaff"
                    value={notifyStaff}
                    onChange={(e) => setNotifyStaff(e.target.value)}
                    options={[{ label: "Darshan", value: "darshan" }]}
                  />
                </div>
              </div>

              <div className={styles.inputsRow}>
                <div className={styles.inputBox}>
                  <label>Any URL</label>
                  <input
                    type="text"
                    className={styles.input}
                    placeholder="Paste any related URL"
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                  />
                </div>
                <div className={styles.inputBox}>
                  <label>Attachment of Video *</label>
                  <label htmlFor="videoUpload" className={styles.uploadBox}>
                    <BsUpload size={28} />
                    <span>Browse and upload files from device</span>
                  </label>
                  <input
                    id="videoUpload"
                    type="file"
                    onChange={handleVideoUpload}
                    style={{ display: "none" }}
                  />
                </div>
              </div>

              <div>
                <label>Description</label>
                <textarea
                  className={styles.textarea}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Write the announcement description here"
                />
              </div>

              <div className={styles.actionsRow}>
                <SaveAndCancel
                  onSave={handleSave}
                  onCancel={() => dispatch(closeModal())}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Assign Staff Section from AddProgram */}
      <div className={styles.sectionCard}>
        <div className={styles.sectionHeader}>
          <HeadingAndIcon icon={<FaUserPlus />} heading="Assign Staff" />
        </div>
        <div className={styles.studentdata}>
          <div className={styles.controls}>
            <SearchBar
              placeholder="Search Staff"
              onChange={(e) => setSearch(e.target.value)}
            />
            <Dropdown
              bgColor="var(--Utility_Color1)"
              label="Room"
              options={["Room A", "Room B"]}
            />
          </div>

          <div className={styles.listHeader}>
            <label>
              <input
                type="checkbox"
                checked={
                  selectedStaff.length === filteredStaff.length &&
                  filteredStaff.length > 0
                }
                onChange={(e) =>
                  setSelectedStaff(
                    e.target.checked ? filteredStaff.map((s) => s.id) : []
                  )
                }
              />{" "}
              Select All
            </label>
            <span>{selectedStaff.length} Selected</span>
          </div>

          <div className={styles.grid}>
            {filteredStaff.map((staff) => (
              <label key={staff.id} className={styles.studentBox}>
                <input
                  type="checkbox"
                  checked={selectedStaff.includes(staff.id)}
                  onChange={() => handleCheckboxChange(staff.id)}
                />
                <span>{staff.name}</span>
              </label>
            ))}
          </div>

          <div className={styles.footerActions}>
            <SaveAndCancel onSave={handleSave} onCancel={handleCancel} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffAnnouncement;
